//Auth
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const REGISTER = "REGISTER";
export const VERIFY_OTP = "VERIFY_OTP";
export const FORGET_PASSWORD = "FORGET_PASSWORD";
 